import { GetBannerPlaylistToneDto, GetBannerPlaylistToneDtoImpl } from './getbannerplaylisttonedto';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';

export class GetPlaylistBuilder
{
    constructor(private playlistList: any)
    {
        if(playlistList.categoryList === undefined)
        {
            throw new NoDataException("Get Playlist data doesnt exists");
        }
    }

    buildAll(): GetBannerPlaylistToneDto[]
    {
        return this.parseGetPlaylistDetailsResponse();
    }
    
    private parseGetPlaylistDetailsResponse(): GetBannerPlaylistToneDto[]
    {
        let listOfPlaylist: GetBannerPlaylistToneDto[] = [];
        
        let playlistDetailsResponse = null;
        this.playlistList.categoryList.forEach((categoryItem: any) =>
        {
            playlistDetailsResponse = new GetBannerPlaylistToneDtoImpl();
            // playlistDetailsResponse.setImgPath(categoryItem.previewImage);

            // playlistDetailsResponse.setPreviewContent(categoryItem.previewContent);
            playlistDetailsResponse.setImgPath(categoryItem.toneIdpreviewImageUrl);
            playlistDetailsResponse.setPreviewContent(categoryItem.toneIdStreamingUrl);
            playlistDetailsResponse.setValidity(categoryItem.validity);
            playlistDetailsResponse.setPlaylistResponseDescription(categoryItem.playlistResponseDescription);
            playlistDetailsResponse.setId(categoryItem.toneCode);
            playlistDetailsResponse.setChannelName(categoryItem.channelName);
            playlistDetailsResponse.setArtistName(categoryItem.artist);
            playlistDetailsResponse.setParentToneCode(categoryItem.parentToneCode);
            playlistDetailsResponse.setChildToneCodes(categoryItem.childToneCodes);
            playlistDetailsResponse.setEntityId(categoryItem.entityId);
            playlistDetailsResponse.setType(categoryItem.type);
            
            listOfPlaylist.push(playlistDetailsResponse);
        });
        return listOfPlaylist;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/getplaylist/getplaylistbuilder.ts